import { Component, AfterViewInit, OnDestroy, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TdLoadingService, TdMediaService, TdDialogService, } from '@covalent/core';
import { MdSelect } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs';

import { PatronesService, LoginService, } from '../../../../../services/';

import { Patron } from '../../../../../models';

@Component({
  selector: 'qs-cerradosdetalle',
  styleUrls: ['./cerradosdetalle.component.scss'],
  templateUrl: './cerradosdetalle.component.html',
  viewProviders: [ PatronesService, ],
  encapsulation: ViewEncapsulation.None,
})

export class CerradosDetalleComponent implements AfterViewInit, OnDestroy {

  private mode: string;
  private title: string;
  private titulo: string;

  private idPaciente: string;
  private accion: string;

  private patron: Patron;
  private oldPatron: Patron;
  private idRespuesta: string;
  private grupo: any;
  public agrupaciones: { agrupacion: any; }[];
  public agrupacion: any;
  public size: boolean;

  constructor(private _loadingService: TdLoadingService,
    public media: TdMediaService,
    private _dialogService: TdDialogService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _patronesService: PatronesService,
    private _loginService: LoginService,
    private _changeDetectorRef: ChangeDetectorRef) {
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this.titulo = this._loginService.transient.textoPatron;
    this.patron = new Patron();
    this.oldPatron = new Patron();
    if (this._loginService.transient) {
      this.mode = 'edit';
      this.title = 'Editar';
      this.patron = this._loginService.transient;
    } else {
      this.mode = 'add';
      this.title = 'Añadir';
    }
  }

  ngAfterViewInit(): void {
    this.media.broadcast();
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this._loadingService.register('cerradosdetalle.load');
    this._changeDetectorRef.detectChanges();

    this.idRespuesta = String(this._loginService.transient.idRespuesta);

    let idPatron: number = this._loginService.transient.idPatron;
    this.titulo = this._loginService.transient.textoPatron;

    this._patronesService.obtenerPreguntasRespuestasPatronValorado(this.idRespuesta, this.idPaciente)
    .subscribe((res: any) => {

      this.patron = res.respuesta;

      this.agrupaciones = res.respuesta.agrupaciones;

      this.agrupacion = this.agrupaciones[0].agrupacion;

      if (this.agrupaciones.length > 1) {
        this.size = true;
      } else {
        this.size = false;
      }

      this._loadingService.resolve('cerradosdetalle.load');
    }, (error: Error) => {
      this._loginService.mostrarMensaje('Error obteniendo motivos de consulta.', 'OK', 6000);
      this._loadingService.resolve('cerradosdetalle.load');
    });
  }

  ngOnDestroy(): void {
    this._loginService.transient = '';
  }
}



// WEBPACK FOOTER //
// ./src/app/consulta/modanamnesis/cerrados/cerradosdetalle/cerradosdetalle.component.ts